import { request, getCompanyId } from '../utils'
import {
  API_STEPATHON_LIST_AND_CREATE,
  API_STEPATHON_UPDATE,
  API_STEPATHON_DEACTIVATE,
  API_STEPATHON_ACTIVATE,
  API_STEPATHON_TEAM_UPLOAD,
  API_STEPATHON_MEMBER_UPLOAD,
  API_STEPATHON_TEAM_UPLOAD_STATUS,
  API_STEPATHON_UPLOADER_BUG_REPORT,
  API_TEAM_LIST_PAGE,
  API_MEMBER_LIST_PAGE, 
  API_TEAM_MEMBER_LIST_PAGE
} from '../routes/api'

class StepathonApi {
  static fetchStepathonList (options, onSuccess, onError) {
    return request({ url: API_STEPATHON_LIST_AND_CREATE  + '?' + getCompanyId() , params: options, method: 'get', ...options }, onSuccess, onError);
  }

  static createStepathon (options, onSuccess, onError) {
    return request({ url: API_STEPATHON_LIST_AND_CREATE  + '?' + getCompanyId(), params: options, method: 'post', ...options }, onSuccess, onError);
  }

  static updateStepathon(options, onSuccess, onError) {
    return request(
      { url: API_STEPATHON_UPDATE(options.id) + '?' + getCompanyId(), method: 'put', ...options },
      onSuccess,
      onError
    );
  }
  
  static deactivateStepathon(options, onSuccess, onError) {
    return request(
      { url: API_STEPATHON_DEACTIVATE(options.id) + '?' + getCompanyId(), method: 'put', ...options },
      onSuccess,
      onError
    );
  }

  static activateStepathon(options, onSuccess, onError) {
    return request(
      { url: API_STEPATHON_ACTIVATE(options.id) + '?' + getCompanyId(), method: 'put', ...options },
      onSuccess,
      onError
    );
  }

  static stepathon_team_bulk_upload(options, onSuccess, onError) {
    return request({ url: API_STEPATHON_TEAM_UPLOAD, method: 'post', ...options }, onSuccess, onError);
  }

  static stepathon_member_bulk_upload(options, onSuccess, onError) {
    return request({ url: API_STEPATHON_MEMBER_UPLOAD, method: 'post', ...options }, onSuccess, onError);
  }

  static stepathon_team_upload_status(options, onSuccess, onError) {
    return request({ url: API_STEPATHON_TEAM_UPLOAD_STATUS(options.id), method: 'get', ...options }, onSuccess, onError);
  }

  static stepathon_team_uploader_bug_report(options, onSuccess, onError) {
    return request({ url: API_STEPATHON_UPLOADER_BUG_REPORT(options.id), method: 'get', ...options }, onSuccess, onError);
  }

  static fetchTeamListPage(options, onSuccess, onError) {
    return request(
      { url: API_TEAM_LIST_PAGE(options.id) + '?' + getCompanyId(), method: 'get', ...options }, onSuccess, onError
    );
  }

  static fetchMemberListPage(options, onSuccess, onError) {
    return request(
      { url: API_MEMBER_LIST_PAGE(options.id, options.term) + '&' + getCompanyId(), method: 'get', ...options }, onSuccess, onError
    );
  }

  static fetchTeamListMembersPage(options, onSuccess, onError) {
    return request(
      { url: API_TEAM_MEMBER_LIST_PAGE(options.id, options.team_id, options.term) + '&' + getCompanyId(), method: 'get', ...options }, onSuccess, onError
    );
  }

}

export default StepathonApi